<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="queryFormRef" style="flex:1" :inline="true" :model="search" class="demo-form-inline"
                size="mini">
                <el-form-item label="订单号：" prop="order_id">
                    <el-input v-model.trim="search.order_id" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="套餐：" prop="package_code">
                    <el-select v-model="search.package_code" clearable @change="Search">
                        <el-option v-for="item in packlist" :key="item.code" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订阅编号：" prop="subscribe_id">
                    <el-input v-model.trim="search.subscribe_id" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="用户UID：" prop="uid">
                    <el-input v-model.trim="search.uid" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="支付状态：" prop="status">
                    <el-select clearable v-model="search.status" @change="Search">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未支付" :value="0"></el-option>
                        <el-option label="已支付" :value="1"></el-option>
                        <el-option label="已支付（测试）" :value="5"></el-option>
                        <el-option label="已取消" :value="2"></el-option>
                        <el-option label="已过期" :value="3"></el-option>
                        <el-option label="已删除" :value="4"></el-option>
                        <el-option label="待收款" :value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="Search">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="clearCondition">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 列表 -->
        <el-table :data="list" size="mini">
            <el-table-column label="用户UID" width="90">
                <template v-slot="scope">
                    <span>{{ scope.row.uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="SIM ID" width="110">
                <template v-slot="scope">
                    <span>{{ scope.row.sim_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="IEMI" width="100">
                <template v-slot="scope">
                    <span>{{ scope.row.imei }}</span>
                </template>
            </el-table-column>
            <el-table-column label="UUID" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="订阅编号" width="100">
                <template v-slot="scope">
                    <span>{{ scope.row.subscribe_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="订单号" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.order_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐名称" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.package_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="金额/币种" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.amount }} / {{ scope.row.currency }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款状态" width="120">
                <template v-slot="scope">
                    <span style="display: inline-block;margin-right: 6px;">
                        <el-tag v-if="scope.row.is_test == 1">测试</el-tag>
                    </span>
                    <span>{{ ChangeStatus(scope.row.status) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款类型" align="right" width="120">
                <template v-slot="scope">
                    <span style="display: inline-block;text-align: center;margin-right: 6px;">{{
                        ChangePayType(scope.row.pay_type) }}</span>
                    <span style="display: inline-block;">
                        <el-tag v-if="scope.row.is_sub == 0">非订阅</el-tag>
                        <el-tag v-else type="success">订阅</el-tag>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="交易号" width="110">
                <template v-slot="scope">
                    <span>{{ scope.row.payer_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款时间" width="110" prop="pay_time" :formatter="(row) => row.pay_time && util.dateFormat(row.pay_time)
                ">
            </el-table-column>
            <el-table-column label="创建时间" width="110">
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template v-slot="scope">
                    <el-button type="info" size="small" @click="openPackageDetail(scope.row)">套餐详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total" background>
        </el-pagination>

        <el-dialog class="package-detail-dialog" title="套餐详情" v-model="packageDetailVisible" width="900px"
            @close="onPackageDetailClose">
            <div v-loading="packageDetailLoading">
                <el-form class="package-detail-form" :model="packageDetail" label-width="110px" size="small">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="订单号">
                                <el-input disabled v-model="packageDetail.order_id" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="订阅编号">
                                <el-input disabled v-model="packageDetail.subscribe_id" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="用户UID">
                                <el-input disabled v-model="packageDetail.uid" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="SIM ID">
                                <el-input disabled v-model="packageDetail.sim_id" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="IMEI">
                                <el-input disabled v-model="packageDetail.imei" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="UUID">
                                <el-input disabled v-model="packageDetail.uuid" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="套餐编码">
                                <el-input disabled v-model="packageDetail.package_code" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="套餐名称">
                                <el-input disabled v-model="packageDetail.package_name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="状态">
                                <el-input disabled v-model="packageDetail.status" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="激活时间">
                                <el-input disabled v-model="packageDetail.active_time_text"
                                    autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="套餐时长">
                                <el-input disabled v-model="packageDetail.package_time_text"
                                    autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开始时间">
                                <el-input disabled v-model="packageDetail.start_time_text"
                                    autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结束时间">
                                <el-input disabled v-model="packageDetail.end_time_text" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="流量上限">
                                <el-input disabled v-model="packageDetail.data_limit_text"
                                    autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="已用流量">
                                <el-input disabled v-model="packageDetail.data_used_text" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="创建时间">
                                <el-input disabled v-model="packageDetail.create_time_text"
                                    autocomplete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="packageDetailVisible = false">关 闭</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import util from '../../../util/util'
import {
    pay_type,
    order_status
} from '../../../assets/js/dictionary'
import api from '../../../axios/pack'

const getEmptyPackageDetail = () => ({
    id: '',
    uid: '',
    sim_id: '',
    imei: '',
    uuid: '',
    appid: '',
    order_id: '',
    subscribe_id: '',
    package_code: '',
    package_name: '',
    status: '',
    active_time: 0,
    active_by: '',
    package_time: '',
    time_unit: '',
    start_time: 0,
    end_time: 0,
    data_type: '',
    user_priority: '',
    data_limit: 0,
    data_used: 0,
    create_time: 0,
    created_at: '',
    updated_at: '',
    active_time_text: '--:--:--',
    start_time_text: '--:--:--',
    end_time_text: '--:--:--',
    create_time_text: '--:--:--',
    package_time_text: '',
    data_limit_text: '',
    data_used_text: ''
})

export default {
    name: 'simdataorderlist',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            util: util,
            search: {
                page: 1,
                limit: 16,
                order_id: '',
                package_code: '',
                status: '',
                subscribe_id: '',
                uid: ''
            },
            list: [],
            total: 0,
            packlist: [],
            packageDetailVisible: false,
            packageDetailLoading: false,
            packageDetail: getEmptyPackageDetail()
        }
    },
    computed: {},
    watch: {},
    methods: {
        getEmptyPackageDetail() {
            return getEmptyPackageDetail()
        },
        GetPack() {
            api.FourGPackageList({
                page: 1,
                limit: 500
            }).then(res => {
                if (res.data.code == 200) {
                    this.packlist = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        openPackageDetail(row) {
            if (!row || !row.order_id) {
                this.$message.error('订单号为空')
                return
            }

            this.packageDetailVisible = true
            this.packageDetailLoading = true
            this.packageDetail = this.getEmptyPackageDetail()
            this.packageDetail.order_id = row.order_id
            this.packageDetail.subscribe_id = row.subscribe_id || ''
            this.packageDetail.uid = row.uid || ''
            this.packageDetail.sim_id = row.sim_id || ''
            this.packageDetail.imei = row.imei || ''
            this.packageDetail.uuid = row.uuid || ''
            this.packageDetail.package_name = row.package_name || ''

            this.api.SimdataDataInfo({
                order_id: row.order_id
            }).then(res => {
                this.packageDetailLoading = false
                if (res.data.code == 200) {
                    const data = res.data.data || {}
                    this.packageDetail = {
                        ...this.getEmptyPackageDetail(),
                        ...data,
                        active_time_text: data.active_time ? util.dateFormat(data.active_time) : '--:--:--',
                        start_time_text: data.start_time ? util.dateFormat(data.start_time) : '--:--:--',
                        end_time_text: data.end_time ? util.dateFormat(data.end_time) : '--:--:--',
                        create_time_text: data.create_time ? util.dateFormat(data.create_time) : '--:--:--',
                        package_time_text: `${data.package_time || ''}${data.time_unit ? ' ' + data.time_unit : ''}`,
                        data_limit_text: this.formatDataLimit(data.data_limit, true),
                        data_used_text: this.formatDataLimit(data.data_used, false)
                    }
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
                this.packageDetailVisible = false
            }).catch(() => {
                this.packageDetailLoading = false
                this.$message.error('获取失败')
                this.packageDetailVisible = false
            })
        },
        onPackageDetailClose() {
            this.packageDetailLoading = false
            this.packageDetail = this.getEmptyPackageDetail()
        },
        handleCurrentChange(val) {
            this.search.page = val
            sessionStorage.setItem('currentPage', val)
            this.Search()
        },
        Search() {
            let filter = {
                ...this.search
            }
            this.api.SimdataOrderList(filter).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data || []
                    this.total = res.data.data.page_info.total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        getSchoolWebModuleMessageListFunc() {
            setTimeout(() => {
                if (sessionStorage.getItem("currentPage") && sessionStorage.getItem("currentPage") !== 1) {
                    this.search.page = Number(sessionStorage.getItem("currentPage"))
                }
                this.Search()
            }, 0)
        },
        formatDataLimit(dataLimitKb, treatZeroAsUnlimited = true) {
            if (dataLimitKb === null || dataLimitKb === undefined || dataLimitKb === '') return '--'
            const kb = Number(dataLimitKb)
            if (Number.isNaN(kb)) return '--'
            if (treatZeroAsUnlimited && kb === 0) return '无限制'
            if (kb < 1024) return `${kb.toFixed(0)}KB`

            const mb = kb / 1024
            return mb >= 1024 ? `${(mb / 1024).toFixed(1)}GB` : `${mb.toFixed(0)}MB`
        },
        clearCondition() {
            this.reset()
            this.Search()
        },
        reset() {
            this.search = {
                ...this.search,
                order_id: '',
                package_code: '',
                status: '',
                subscribe_id: '',
                uid: ''
            }
        },
        ChangeStatus(item) {
            return util.handleValueDisplay(order_status, item)
        },
        ChangePayType(item) {
            return util.handleValueDisplay(pay_type, item)
        },
        dateFormat(time) {
            return util.dateFormat(time)
        }
    },
    filters: {},
    mounted() {
        this.getSchoolWebModuleMessageListFunc()
    },
    created() {
        this.GetPack()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
    ::v-deep(.package-detail-dialog .el-dialog__body) {
        padding-top: 12px;
    }
    ::v-deep(.package-detail-form .el-form-item) {
        margin-bottom: 12px;
    }
    ::v-deep(.package-detail-form .el-form-item__label) {
        padding-right: 12px;
    }
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
